import type { Components, Theme } from '@mui/material/styles'
import { colorTokens } from '../tokens/colorTokens'

export const buttonTheme: Components<Theme> = {
    MuiButton: {
        defaultProps: {
            variant: 'contained',
            disableElevation: true,
            loadingPosition: 'center',
        },
        styleOverrides: {
            root: {
                width: 'auto',
                minWidth: 150,
                flex: '0 0 auto',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                textTransform: 'none',
                '&.Mui-disabled': {
                    cursor: 'not-allowed',
                    pointerEvents: 'auto', // keep cursor visible; the native disabled attribute already blocks clicks
                    color: colorTokens.text.disabled,
                },
                '&:link, &:visited': {
                    textDecoration: 'none',
                },
            },
            loadingIndicator: {
                color: 'inherit', // Spinner inherits button text color (white for contained, dark for outlined)
            },
        },
        variants: [
            {
                props: { variant: 'contained', color: 'primary' },
                style: ({ theme }) => ({
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    '&:link, &:visited': {
                        color: theme.palette.primary.contrastText,
                    },
                    '&:hover:not(.Mui-disabled)': {
                        backgroundColor: theme.palette.primary.dark,
                    },
                    '&.Mui-disabled': {
                        backgroundColor: colorTokens.surface.disabled,
                    },
                }),
            },
            {
                props: { variant: 'outlined', color: 'primary' },
                style: ({ theme }) => ({
                    color: theme.palette.primary.main,
                    borderColor: theme.palette.primary.main,
                    '&:link, &:visited': {
                        color: theme.palette.primary.main,
                    },
                    '&:hover': {
                        borderColor: theme.palette.primary.dark,
                    },
                    '&.Mui-disabled': {
                        backgroundColor: 'transparent',
                        borderColor: colorTokens.border.default,
                    },
                }),
            },
        ],
    },
}
